<template>
  <base-floating-card id="reset-password" @close="close">
    <div id="reset-password-wrapper">
      <reset-password class="art" />
      <div class="input-wrapper">
        <Input
          class="scs-input"
          heading="New Password"
          placeholder="Examp1e$"
          :error="error"
          @scs-input="input"
        />
        <p class="error-text" v-if="passwordError.match">
          <i>Oops! Passwords don't match! Try again.</i>
        </p>
        <p class="error-text" v-if="passwordError.strength">
          <i
            >Passwords must contain an uppercase letter, lowercase letter, and a
            number.</i
          >
        </p>
        <div id="reset-password-buttons-wrapper">
          <round-button-with-icon
            :icon="processing ? 'spinner' : 'x'"
            @click="close"
          />
          <round-button-with-icon
            :icon="processing ? 'spinner' : 'checkmark'"
            @click="submit"
          />
        </div>
      </div>
    </div>
  </base-floating-card>
</template>
<script>
import BaseFloatingCard from "../BaseFloatingCard.vue";
import Input from "../../../Elements/Input.vue";
import RoundButtonWithIcon from "../../../UI/RoundButtonWithIcon.vue";
import ResetPassword from "../../Illustrations/ResetPassword.vue";

export default {
  data() {
    return {
      processing: false,
      passwordError: {
        strength: false,
      },
      value: undefined,
    };
  },
  computed: {
    error() {
      return this.passwordError.strength;
    },
  },
  methods: {
    input(value) {
      this.value = value;
    },
    async submit() {
      this.passwordValidationBlock();
      if (!this.error) {
        this.processing = true;
        await this.$store.dispatch("resetUserPassword", {
          username: this.contact.username
            ? this.contact.username
            : this.contact.email,
          password: this.value,
          userId: this.contact.userId,
        });
        this.processing = false;
        this.close();
      }
    },
    passwordValidationBlock() {
      const re = new RegExp(
        "^(?=.*d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$"
      );
      if (!re.test(this.value)) {
        this.passwordError.strength = true;
      } else {
        this.passwordError.strength = false;
      }
    },
    close() {
      this.$emit("close");
    },
  },
  created() {},
  components: {
    BaseFloatingCard,
    Input,
    RoundButtonWithIcon,
    ResetPassword,
  },
  emits: ["close"],
  props: ["contact"],
};
</script>
<style scoped>
@media screen {
  #reset-password-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
  }

  .art {
    height: 100px;
    width: 100px;
    margin: 40px;
  }
  p {
    color: red;
    font-size: 0.75rem;
  }

  .input-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  #reset-password-buttons-wrapper {
    width: 150px;
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
  }
  @media (min-width: 800px) {
    #reset-password-wrapper {
      width: 600px;
      flex-direction: row;
    }

    .art {
      height: 150px;
      width: 150px;
      margin: 40px 40px 40px 0;
    }

    .input-wrapper {
      width: 60%;
      flex-direction: row;
    }
  }
}
</style>
